import { OwcChip } from "@one/react";
import React, { useContext } from "react";
import { EquipmentsContext } from "./equipments-context/context";
import { getFieldValue } from "@digitallab/grid-common-components";

const EquipmentTagsRenderer = (params) => {
  const {
    myLabEquipment
  } = useContext(EquipmentsContext);

  let paramsValue = null;
  paramsValue = getFieldValue(params?.data, "id")?.toString();

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
        {myLabEquipment.includes(paramsValue) ? <OwcChip
          outlined={true}
          style={{
            minHeight: "22px",
          }}
          text={"My Lab"}
        >
          <strong>{"My Lab"}</strong>
        </OwcChip> : "-"
        }
      </div>
    </>
  );
};

export default EquipmentTagsRenderer;
